import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../services/authService';

/**
 * Component to redirect users to appropriate route based on their role
 */
const RoleBasedRedirect = () => {
  const user = authService.getCurrentUser();

  const roleRedirects = {
    employee: '/employee/home',
    company: '/company/vacancies',
    recruitment_company: '/recruitment-company/vacancies',
    admin: '/dashboard',
  };

  const redirectPath = roleRedirects[user?.role] || '/employee/vacancies';
  return <Navigate to={redirectPath} replace />;
};

export default RoleBasedRedirect;


